import { render, staticRenderFns } from "./OpenSettingsButton.vue?vue&type=template&id=64666559&scoped=true&"
import script from "./OpenSettingsButton.vue?vue&type=script&lang=js&"
export * from "./OpenSettingsButton.vue?vue&type=script&lang=js&"
import style0 from "./OpenSettingsButton.vue?vue&type=style&index=0&id=64666559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64666559",
  null
  
)

export default component.exports